// extracted by mini-css-extract-plugin
module.exports = {"Card":"AdminDashCard_Card__33fBF","CardButton":"AdminDashCard_CardButton__jxBEx","CardIcon":"AdminDashCard_CardIcon__rPHB_"};